<template>
  <div class="product_detail">
    <div class="product_swiper">
      <Swipe class="my-swipe"    dots="outside" indicator-color="#F35219" :stop-propagation="false">
        <template v-if="detail.imgProduct" >
          <SwipeItem v-if="detail.video">
            <video id="myVideo"  controls objectFit="contain" width="100%" height="100%" >
              <source :src="toPicUrl(detail.video)" type="video/mp4">
              Your browser does not support the video
            </video>
          </SwipeItem>
          <SwipeItem v-for="(i,index) in detail.imgProduct" :key="index" class="item">
            <img :src="toPicUrl(i)" alt=""  @click.prevent="imgIndex=index;show=true">
          </SwipeItem>
        </template>
      </Swipe>
      <a  class="buy_link" :href="detail.buyLink" v-if="detail.buyLink">
        <img src="/static/img/cart.png" alt="" class="cartIcon">
        <span>Click to buy</span>
      </a>
    </div>
    <!-- 产品简介 -->
    <div class="detail_info">
      <Skeleton title :row="3" v-if="isLoading"/>
      <template v-else>
        <p class="title">{{detail.name}}</p>
        <div class="desc">{{detail.synopsis}}</div>
      </template>
    </div>
    <!-- 产品参数 -->
    <div class="product_params">
      <Skeleton  :row="4" v-if="isLoading"/>
      <template v-else>
        <!-- 网络 -->
        <div class="item" v-if="detail.networkMode">
          <div class="name">Network:</div>
          <div class="params_desc">{{detail.networkMode}}</div>
        </div>
        <div class="item" v-if="detail.siteCoverage">
          <div class="name">Coverage:</div>
          <div class="params_desc">{{detail.siteCoverage}}</div>
        </div>
        <div class="item" v-if="detail.gainMax">
          <div class="name">Maximum:</div>
          <div class="params_desc">{{detail.gainMax}}</div>
        </div>
        <div class="item" v-if="detail.operators">
          <div class="name">Operator:</div>
          <div class="params_desc">{{detail.operators}} </div>
        </div>
        <!-- 特正标签 -->
        <ul class="list" v-if="detail.label && detail.label.length>0">
          <template v-for="(item, index) in detail.label">
            <li class="feature" v-if="item"  :key="index">
              <span class="icon"></span>
              <p>{{item}}</p>
            </li>
          </template>
        </ul>
      </template>
    </div>
    <template>
      <Skeleton title :row="3" :loading="isLoading" class="highlights">
        <!-- 产品亮点 -->
        <h5 class="product_highlights">Highlight</h5>
        <div class="detail_info" v-html="detail.highlights">{{detail.highlights}}</div>
      </Skeleton>
    </template>
    <Overlay :show="show" :lock-scroll="false" class-name="modalimg" >
      <Swipe :initial-swipe="imgIndex"  class="swiper" indicator-color="#F35219" :stop-propagation="false">
        <SwipeItem v-for="(i,index) in detail.imgProduct" :key="index" class="item" @click="imgUrl = '';show=false">
          <img :src="toPicUrl(i)" alt=""  >
        </SwipeItem>
      </Swipe>
    </Overlay>
  </div>
</template>

<script>
import { toPicUrl} from '../../utils/common'
import request from '../../api/request'
  export default {
    name: '',
    data() {
      return {
        isLoading: true,
        id: '',
        detail: {},
        show: false,
        imgIndex: ''
        // cartImg: require('@/assets/img/cart.png')
      }
    },
    created () {
      this.id =  this.$route.params.id
      if (this.id) {
        this.getData()
      }
    },
    methods: {
      toPicUrl,
      getData () {
        request('get', 'cms/product/info/queryById', {id: this.id}).then((res) => {
          if (res.code === 200) {
            this.detail = {
              ...res.data,
              label: res.data.label?res.data.label.split(';'): [],
              imgProduct: res.data.imgProduct?res.data.imgProduct.split(','): []
            }
            this.isLoading = false
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
.product_detail{
  width: 345px;
  margin:0 auto;
  padding-bottom: 30px;
  .product_swiper{
    position: relative;
    width: 345px;
    height: 175px;
    margin: 0 auto;
    overflow: hidden;
    .my-swipe{
      width: 100%;
      height: 100%;
    }
    .buy_link{
      position: absolute;
      // z-index: 200;
      width:345px;
      height:25px;
      background:rgba(102,102,102,0.1);
      bottom: 0px;
      color: #00C8CA;
      font-size: 14px;
      text-align: center;
      line-height: 25px;
      .cartIcon{
        display: inline-block;
        width: 20px;
        height: 20px;
        vertical-align: middle;
        margin-right: 8px;
      }
    }
    .item{
      width: 100%;
      height: 100%;
      img{
        width: 100%;
        height: auto
      }
    }
  }
  .detail_info{
    width: 342.5px;
    margin: 15px auto 0;
    font:  400 12px 'PingFang-SC-Regular' ;
    color: #363C54;
    .title{
      font: Bold 14px 'PingFang-SC-Bold';
      margin-bottom: 10px;
    }
    .desc, p{line-height: 1.6;}
  }
  .product_params{
    width: 100%;
    margin-top: 16px;
    font: bold 12px 'PingFang SC';
    color: #363C54;
    // line-height: 16PX;
    .item {
      display: flex;
      // margin-bottom: 10px;
      align-items: baseline;
      line-height: 2;
      .name {width: 120px;}
      .params_desc{
        flex:1;
        word-break: normal;
        line-height: 1.6;
      }
    }
    .list {
      margin: 5px 0 10px 62px;
      .feature {
        display: flex;
        line-height: 2;
        align-items: baseline;
        .icon {
          display: inline-block;
          width:10px;
          height:15px;
          margin-right: 8px;
          border-color: #00C8CA;
          border-style: solid;
          border-width: 0 2px 2px 0;
          transform: rotate(45deg);
          border-radius:0 0 2px 0;
        }
        p{flex:1}
      }
    }
  }
  .highlights{
    margin-top: 24px;
  }
  .product_highlights{
    margin-top: 24px;
    font-size: 14px;
    font-family:PingFang SC;
  }
}
</style>